import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CurrentUserService } from '../services/current-user.service';
import { AuthService } from '../services/auth-service';

@Injectable({
  providedIn: 'root',
})
export class GuestGuard implements CanActivate {
  private currentUserService = inject(CurrentUserService);
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(): boolean {
    if (this.currentUserService.isLoggedIn()) {
      const scopeIds = this.authService.getScopeIds().map((id) => Number(id));

      if (scopeIds.length === 0) {
        this.currentUserService.logout();
        return true;
      }

      const adminScopeIds = [
        110001, 110002, 110003, 110004, 200002, 200003, 200004, 200005, 200006, 200007, 200008, 200009, 200010, 200011,
        200012, 200013, 210001, 210002, 210004, 210005, 210006, 220001, 220002, 220003, 220004, 250001, 250002, 250003,
        250004, 250005, 250006, 250007, 250008, 250009, 250010, 280001, 280002, 280003, 280004, 280005, 280006, 280007,
        280008, 280010, 280011, 280012, 280013, 280014, 280015, 280016, 280020, 280021, 280022, 280023, 280024, 280025,
        280026, 290101, 290102, 290103, 290104, 310001, 310002, 310003, 310004, 310005, 310006, 310007, 310008, 310009,
        310010, 310011, 310012, 310013, 310014, 310015, 310016, 310017, 310018, 310019, 310020, 310025, 310026, 310027,
        310029, 310030, 310031, 310032, 310033, 310034, 310035, 310037, 310038, 310039, 310040, 310041, 310042, 310043,
        310045, 310046, 310047, 310048, 310049, 310050, 310051, 310052, 310053, 310054, 310055, 310056, 510003, 510005,
        510006, 510008, 510010, 510011, 510012, 510013, 510014, 510015, 510016, 510017, 510018, 520001, 520002, 520003,
        520004, 530010, 530011, 530012, 530013, 530014, 530015, 530016, 530017, 260001, 260002, 260003, 260004, 260005,
        260006, 260007, 260008,
      ];

      const hasAdminScopes = scopeIds.some((id) => adminScopeIds.includes(id));

      if (hasAdminScopes) {
        this.router.navigate(['/admin'], { replaceUrl: true });
      } else {
        this.router.navigate(['/user'], { replaceUrl: true });
      }

      return false;
    }
    return true;
  }
}
